
<template>
  <div
    class="vqb-rule"
    :class="{ 'panel panel-info form-inline': styled }"
  >
    <div
      v-show="!showOnly"
      class="col-xs-12 hidden-md hidden-lg"
    >
      <!--Remove the rule!-->
      <button
        type="button"
        :class="{ 'close pull-right': styled }"
        @click="remove"
        v-safe-html="labels.removeRule"
      />
    </div>

    <div :class="{ 'form-group row': styled }">
      <div class="col-xs-6 col-md-3">
        <template v-if="showOnly">
          {{ trans('filters.' + rule.label) }}
        </template>
        <template v-else>
          <label
            style="width:100%;text-align:left"
            class="form-control disabled"
          >{{ trans('filters.' + rule.label) }} </label>
        </template>
      </div>
      <div class="col-xs-6 col-md-2">
        <template v-if="showOnly">
          {{ trans('filters.' + query.operator) }}
        </template>
        <template v-else>
          <select
            v-model="query.operator"
            :class="{ 'form-control': styled }"
          >
            <option
              v-for="operator in rule.operators"
              :value="operator"
            >
              {{ trans('filters.' + operator) }}
            </option>
          </select>
        </template>
      </div>
      <div class="hidden-sm  hidden-xs col-md-1" />
      <!-- the text component -->
      <div class="col-xs-11 col-md-5">
        <!--<input :class="{ 'form-control': styled }" v-if="rule.inputType === 'text'" type="text" v-model="query.value" :placeholder="labels.textInputPlaceholder">-->
        <!--</input>-->
        <template v-if="rule.inputType === 'text'">
          <default-rule
            v-model="query.value"
            :operator="query.operator"
            :styled="styled"
            type="text"
            :placeholder="labels.textInputPlaceholder"
            :show-only="showOnly"
          />
        </template>

        <template v-if="isCustomComponent">
          <component
            :is="rule.component"
            :show-only="showOnly"
            :value="query.value"
            :custom="rule.custom"
            :suggest_type="rule.suggest_type"
            :include="included"
            @input="updateQuery"
          />
        </template>
      </div>

      <div
        v-show="!showOnly"
        class="col-md-1 hidden-xs hidden-sm"
      >
        <!--Remove the rule!-->
        <button
          type="button"
          :class="{ 'close pull-right': styled }"
          @click="remove"
          v-safe-html="labels.removeRule"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from './utilities.js'
import DefaultRule from '../QueryDefaultRule'

export default {
  name: 'QueryBuilderRule',
  components: {
    DefaultRule,
  },

  props: ['query', 'index', 'rule', 'styled', 'labels', 'showOnly', 'programId'],

  computed: {

    isCustomComponent () {
      return this.rule.type === 'custom-component'
    },
    included () {
      if (this.programId != null) {
        return { 'program_id': this.programId }
      }
      return {}
    },
  },

  beforeMount () {
    if (this.rule.type === 'custom-component') {
      this.$options.components[this.id] = this.rule.component
    }
  },

  mounted () {
    let updated_query = deepClone(this.query)

    if (this.rule.type === 'custom-component') {
      if (this.query.value === null) {
        updated_query.value = this.rule.default || null
      }
      this.$emit('update:query', updated_query)
    }
  },

  methods: {
    remove: function () {
      this.$emit('child-deletion-requested', this.index)
    },
    updateQuery (value) {
      let updated_query = deepClone(this.query)
      updated_query.value = value

      this.$emit('update:query', updated_query)
    },
  },
}
</script>
